import React, { useState } from 'react';
import { HiOutlineTrash } from 'react-icons/hi2';
import { Table, subscribersColumns } from '../../../commons/Table';
import { useSubscribers } from '../../../../hooks';
import { Alert, Modal } from '../../../commons';
import { DAV_APIS } from '../../../../adapters';
import { SubscribersProps } from '../../../../constants';
import { Card } from '../../../ui/Card';

const Subscribers = () => {
  const [selected, setSelected] = useState({} as SubscribersProps);
  const [refresh, setRefresh] = useState<number | null>(null);
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const onDeleteHandler = (e: any, subscriber: SubscribersProps) => {
    e.stopPropagation();
    setSelected(subscriber);
    setShowModal(true);
  };

  const handleDeleteSubscriber = async () => {
    setIsLoading(true);
    try {
      const res = await DAV_APIS.auth.deleteSubscriber(selected.id as string);
      if (res.status === 204) {
        Alert({ message: 'Deleted Successfully', variant: 'success' });
      }
      setIsLoading(false);
      setShowModal(false);
      setRefresh(Math.random());
    } catch (error) {
      setIsLoading(false);
      setShowModal(false);
      Alert({ message: 'Failed to delete subscriber', variant: 'error' });
    }
  };

  const { subscribers, loading } = useSubscribers(refresh);

  return (
    <div className='space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-700'>
      {/* Page Header */}
      <div className='flex flex-col md:flex-row md:items-center justify-between gap-4'>
        <div>
          <h1 className='text-2xl font-bold text-gray-900 dark:text-white'>
            Newsletter Subscribers
          </h1>
          <p className='text-gray-500 dark:text-gray-400 mt-1 text-sm md:text-base'>
            Manage your audience and marketing outreach list.
          </p>
        </div>

      </div>

      {/* Main Content Card */}
      <Card variant='glass' className='overflow-hidden border-none shadow-xl shadow-gray-200/50 dark:shadow-none'>
        {/* @ts-ignore */}
        <Table
          columns={subscribersColumns}
          data={subscribers}
          loading={loading}
          onDeleteHandler={onDeleteHandler}
          recordName='Subscribers'
          placeholder='Search by name or email...'
        />
      </Card>

      {/* Delete Confirmation Modal */}
      <Modal
        size='sm'
        open={showModal}
        onClose={() => setShowModal(false)}
        onSuccess={handleDeleteSubscriber}
        loading={isLoading}
        successText='Delete Subscriber'
        loadingText='Deleting...'
      >
        <div className='space-y-3'>
          <div className='w-12 h-12 bg-red-50 dark:bg-red-900/20 rounded-full flex items-center justify-center text-red-600 mb-4'>
            <HiOutlineTrash className='w-6 h-6' />
          </div>
          <h2 className='text-xl font-bold text-gray-900 dark:text-white'>Unsubscribe User</h2>
          <p className='text-gray-600 dark:text-gray-400 leading-relaxed'>
            Are you sure you want to remove <span className='font-bold text-gray-900 dark:text-white'>{selected?.name || selected?.email}</span> from the newsletter? This will stop all future marketing emails to this address.
          </p>
        </div>
      </Modal>
    </div>
  );
};

export default Subscribers;
